import React, { ReactNode, CSSProperties } from "react";
import Tooltip from "@mui/material/Tooltip";

interface SimpleFormGroupProps {
    title?: string;
    subtitle?: string;
    tooltip?: string;
    disabledTooltip?: string;
    children: ReactNode;
    required?: boolean;
    className?: string;
    style?: CSSProperties;
    size?: "small" | "medium";
}

const SimpleFormGroup: React.FC<SimpleFormGroupProps> = ({
    title,
    subtitle,
    tooltip,
    disabledTooltip,
    children,
    required = false,
    className = "",
    style,
    size = "medium",
}) => {
    return (
        <div className={`form-group ${className}`} style={style}>
            {(title || tooltip) && (
                <div className="form-group-header">
                    {title && (
                        <div className={`form-group-title-${size}`}>
                            <h3>
                                {title}
                                {required && <span className="required-asterisk">*</span>}
                            </h3>
                            {tooltip && (
                                <Tooltip title={tooltip} arrow>
                                    <span className="tooltip-icon">i</span>
                                </Tooltip>
                            )}
                        </div>
                    )}
                    {subtitle && <p className={`form-group-subtitle-${size}`}>{subtitle}</p>}
                </div>
            )}
            {disabledTooltip ? (
                <Tooltip title={disabledTooltip} arrow>
                    <div className="form-group-content">{children}</div>
                </Tooltip>
            ) : (
                <div className="form-group-content">{children}</div>
            )}
        </div>
    );
};

export default SimpleFormGroup;
